export default __webpack_public_path__ + "static/mayflower-0c3d3a51f5719239dcc7916bdddd663f.png";